<script setup lang="ts">
import { ref, computed, onMounted, defineExpose, onBeforeMount } from 'vue';
// import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { useRoute, useRouter } from 'vue-router';
import  { ElMessage } from 'element-plus'
import { IItemType } from '@/router/routes';
import Faicon from '@/assets/logo-full.svg';
import { sessionStorageManager } from '@/lib/utils';
import ajax from '@/lib/fetch'
import { inject } from 'vue';

const route = useRoute();
const router = useRouter()
const menus = ref([]);
const routes = inject('routes');
const username = ref('')

onBeforeMount(() => {
  menus.value = routes
})
onMounted(() => {
  const name = sessionStorageManager.get('username')
  username.value = name
  const token = sessionStorageManager.getToken();
  if (token) {
    refreshConsume()
  }
})

const handleClose = () => { };

const handleOpen = (index: string) => {
  // 找到对应的菜单项
  const currentMenu = menus.value.find(item => item.name === index)
  if (currentMenu && currentMenu.children && currentMenu.children.length > 0) {
    // 检查当前路由是否已经是这个菜单下的某个子项
    const isAlreadyOnChildRoute = currentMenu.children.some(child =>
        !child.hidden && route.path === child.path
    )

    // 如果当前不在这个菜单的任何子项路由上，才跳转到第一个子项
    if (!isAlreadyOnChildRoute) {
      // 找到第一个可见的子菜单项
      const firstVisibleChild = currentMenu.children.find(child => !child.hidden)
      if (firstVisibleChild && firstVisibleChild.path) {
        // 跳转到第一个子菜单项的路由
        router.push(firstVisibleChild.path)
      }
    }
  }
}

const deleteCookie = (name: string, domain: string) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain}`;
};

const onLogout = () => {
  sessionStorageManager.clear()
  router.replace({
    path: '/login',
  })
};
const consume = ref(null)
const quota = ref(null)
const refreshConsume = async () => {
  try {
    const consumeRes = await ajax.post('/api/balance/today', {type: 'direct'});
    consume.value = consumeRes.balance
    // const quotaRes = await ajax.post('/api/quota/day', {type: 'direct'});
    // quota.value = quotaRes.quota
  } catch (e) {
    ElMessage.error(e.message || '获取限额和消耗失败，请稍后重试')
  }
}
defineExpose({
  refreshConsume
})
</script>

<template>
  <div>
    <el-menu
      active-text-color="#ffd04b"
      background-color="#545c64" 
      class="el-menu-vertical" 
      router
      :default-active="route.path"
      :unique-opened="true"
      text-color="#fff"
      @open="handleOpen" 
      @close="handleClose"
    >
      <div class="img-wrap">
        <img :src="Faicon" width="48"/>
<!--        <span> BOT</span>-->
      </div>
      <div class="split-line"></div>
      <div style="flex: 1;height: calc(74vh);overflow: scroll;margin-bottom: 20px;">
        <div v-for="item in menus" :key="item.name" class="menu-item-wrap">
          <el-sub-menu v-if="item.type === IItemType.submenu && !item.hidden" :index="item.name" :name="item.name" class="sub-menu">
            <template #title>
              <div class="menu-item-flex">
                <div>
                  <FeatherIcon v-if="item.icon" :icon="item.icon"  size="18"  class="el-sub-menu-icon-self" :stroke-width="2"></FeatherIcon>
                </div>
                <div>
                  <span class="menu-name sub-menu-name">{{ item.label }}</span>
                </div>
              </div>
            </template>
            <template v-for="citem in item.children" :key="citem.name">
              <el-menu-item v-if="!citem.hidden" :name="citem.name" :index="citem.path" class="menu-item">
                <div style="flex:1">
                  <div style="display: flex;justify-content: center;">
                    <FeatherIcon icon="circle"  size="14"  class="el-sub-menu-item-self" :stroke-width="2"></FeatherIcon>
                    <span class="menu-name">{{ citem.label }}</span>
                  </div>
                </div>
              </el-menu-item>
            </template>
          </el-sub-menu>
          <el-menu-item v-else-if="item.type === IItemType.menuitem && !item.hidden" :name="item.name" :index="item.path" class="menu-item">
            <div class="menu-item-flex">
              <div>
                <el-icon v-if="item.icon">
                  <component :is="item.icon"></component>
                </el-icon>
              </div>
              <div>
                <span class="menu-name">{{ item.label }}</span>
              </div>
            </div>
          </el-menu-item>
        </div>
      </div>
      <div class="avatar-wrap">
        <div class="avatar"></div>
        <div class="name">
          <el-row>
              <b  style="font-weight: 400; font-size: 1rem">{{username}}</b>
            </el-row>
            <el-row>
              <b style="font-weight: 400; font-size: 0.7rem">余额：{{ consume === null ? '暂无' : consume }}</b>
            </el-row>
        </div>
        <el-dropdown placement="top-start">
          <el-icon class="el-dropdown-link">
            <FeatherIcon icon="more-horizontal" size="12" style="margin-right: 6px; color: #0E684E" :stroke-width="2" ></FeatherIcon>
          </el-icon>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item size="small" @click="onLogout">退出</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </el-menu>
  </div>
</template>

<style scoped lang="scss">
.el-menu-vertical {
  background-color: $secondary-color;
  border-radius: 0.5rem;  // 8px
  box-shadow: 0.125rem 0.125rem 0.5rem $shadow-color;  // 2px 2px 8px
  height: 100%;
  display: flex;
  flex-direction: column;
  // font-family: "HiraMaruProN-W4", "Hiragino Maru Gothic ProN W4", "Hiragino Maru Gothic ProN", sans-serif;
  
  .img-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 2rem;  // 48px
    span {
      font-family: "ToppanBunkyuMidashiGothicStdN-ExtraBold", "Toppan Bunkyu Midashi Gothic Extrabold", "Toppan Bunkyu Midashi Gothic", sans-serif;
      font-weight: 800;
      color: $text-color;
      margin-left: 0.5rem;  // 8px
    }
  }

  .el-sub-menu-icon-self{
    margin-right: 0.75rem;
    margin-bottom: 0.25rem;
  }

  .menu-name{
    margin-top: 0.125rem;
  }
  .menu-item-wrap {
    .sub-menu-name {
      font-weight: 400;
    }

    :deep(.el-sub-menu) {

      // 展开状态下的样式
      &.is-opened {
        .el-sub-menu-icon-self{
          font-weight: 900 !important;
          color: $MenuSelectedColors;
        }

        .el-sub-menu__title {
          .sub-menu-name,
          .el-sub-menu__icon-arrow,
          .el-icon { // 如果有自定义图标
            font-weight: 900 !important;
            color: $MenuSelectedColors;
          }
        }
      }
    }


    :deep(.el-sub-menu__title) {
      height: 2.75rem;  // 42px
      width: 11.25rem;  // 180px
      padding: 0.125rem 0;  // 2px 10px
      border-radius:0;  // 40px
      margin: 1rem 2rem 1rem 0;  // 16px
      font-family: "HiraMaruProN-W4", "Hiragino Maru Gothic ProN W4", "Hiragino Maru Gothic ProN", sans-serif;
      color: $MenuTextColors;
      text-align: left;
      line-height: normal;
      font-size: 0.875rem;

      &:hover {
        background-color: $MenuSelectedMainColorsHover;
        color: $MenuTextColors;
      }


      .el-icon {
        float: right;
        font-size: 1rem;
      }
    }
    
    :deep(.el-sub-menu > .el-menu > .el-menu-item.is-active) {
      background-color: $MenuSelectedColors;
      color: $secondary-color;
      
      &:hover {
        background-color: $MenuSelectedColorsHover; // Keep hover consistent
        color: $secondary-color;
      }
    }
    
    :deep(.el-sub-menu > .el-sub-menu__title > .el-sub-menu__icon-arrow) {
      width: 0.625rem;  // 10px
    }
    
    :deep(.el-sub-menu > .el-menu) {
      background-color: $secondary-color;
    }

    .el-sub-menu-item-self{
      margin-right: 0.5rem;
    }

    .menu-item {
      height: 2.25rem;  // 42px
      width: 11.25rem;  // 180px
      padding: 0.065rem 0 0.125rem 0;  // 2px 10px
      border-radius: 1.5rem;  // 40px
      margin: 1rem 1rem;  // 16px
      font-size: 0.85rem;
      font-family: "HiraMaruProN-W4", "Hiragino Maru Gothic ProN W4", "Hiragino Maru Gothic ProN", sans-serif;
      color:$MenuTextColors;
      text-align: left;
      line-height: normal;

      .el-icon {
        margin-top: 0.075rem;
        float: right;
        font-size: 0.875rem;
      }

      &:hover {
        background-color: $MenuSelectedMainColorsHover;
        color: $MenuSelectedColors;
        font-weight: 600;
        .el-sub-menu-item-self{
          color: $MenuSelectedColors;
          font-weight: 600;
        }
      }
      
      &.is-active {
        background-color: $MenuSelectedColors;
        color: $secondary-color;
        font-weight: 600;
        // 覆盖掉 hover 效果
        &:hover {
          background-color: $MenuSelectedColors !important; // 保持激活状态的背景色
          color: $secondary-color !important; // 保持激活状态的文字颜色
          font-weight: 600;
          .el-sub-menu-item-self{
            color: $secondary-color;
            font-weight: 600;
          }
        }
      }
    }
    
    * {
      vertical-align: middle;
    }
  }
  
  .avatar-wrap {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0 0.625rem 1.875rem;  // 30px
    
    .avatar {
      width: 2.5rem;  // 37px
      height: 2.5rem;  // 37px
      border-radius: 1.125rem;  // 18px
      background: url('@/assets/reply_m.png') no-repeat center center;
      background-size: contain;
      box-sizing: border-box;
    }
    
    .name {
      color: $text-color;
      font-size: 0.8125rem;  // 13px
      margin: 0 0.625rem;  // 10px
      flex: 1;
    }
    
    .email {
      color: $text-secondary;
      font-size: 0.625rem;  // 10px
    }
  }
}

.split-line {
  //border-top: 0.125rem solid $border-color;  // 2px
  margin: 1.25rem 1.25rem 1.125rem 1.25rem;  // 38px 20px 18px 20px
}

.menu-item-flex {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin-left: 2.625rem;  // 42px
  & > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 2.625rem;  // 42px
    line-height: 1.375rem;  // 22px
    .en-font {
      font-size: 0.5rem;  // 8px
    }
  }
}
</style>
